module.exports = __webpack_public_path__ + "static/media/analysis.6f269af2.svg";